import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import { MORTGAGE_FREQUENCY } from "@Shared/@Types/application/application-enums";
import { defineComponent, reactive, toRefs } from "@vue/composition-api";
import * as FieldComponents from "@Shared/components/sections/index";
import { lowerCase } from "@Shared/@Utils/helpers/text";
import { showToast } from "@Shared/@Utils/constants";
import { newMortgageScenarios, copyFrom, formatMoney, formatRate, formatTerm, CalcBean } from "./scenario-calcs";
import Err from "@Broker/@Routes/error";
import Vue from "vue";
import i18n from "@Shared/i18n";
export default defineComponent({
  name: "UserSbScenarioAnalyzer",
  components: _objectSpread({}, FieldComponents),
  props: {
    bean: {
      type: Object,
      required: true
    }
  },
  setup(props) {
    const {
      bean
    } = toRefs(props);
    const calcBean = reactive(CalcBean());
    let showSaved = true;
    function populateSelectedScenarios() {
      let indms;
      for (indms = 0; indms < bean.value.selectedMS.length; indms++) Vue.set(bean.value.selectedMS, indms, newMortgageScenarios());
      indms = -1;
      for (const mortgagescenario of bean.value.savedScenariosList) {
        if (!mortgagescenario.savedSelected) continue;
        if (++indms >= 3) break;
        try {
          const sms = bean.value.selectedMS[indms];
          copyFrom(sms, mortgagescenario);
          const cam = calcBean.round2(bean.value.generatedMS[0].amortizationInterest - sms.amortizationInterest);
          sms.interestDifference = cam;
        } catch (e) {
          Err.handle("populateSelectedScenarios Exception duriing arithmetic operation" + e);
          return -1;
        }
      }
    }
    function updateCurrentScenarioCalcValues() {
      const ms = bean.value.generatedMS[0];
      try {
        const fi = calcBean.calcTermPrinciple(ms.actualPaymentTerm, ms.netRate, ms.totalLoanAmount, ms.interestCompoundDd, ms.paymentFrequencyDd, ms.pAndIPaymentAmount, ms.balanceRemaining);
        ms.termPrincipal = fi;
        const ti = calcBean.calcTermInterest(ms.actualPaymentTerm, ms.interestCompoundDd, ms.netRate, ms.totalLoanAmount, ms.pAndIPaymentAmount, ms.paymentFrequencyDd, fi);
        ms.termInterest = ti;
        const am = calcBean.calcAmortizationInterest(ms.netRate, ms.totalLoanAmount, ms.interestCompoundDd, ms.paymentFrequencyDd, ms.pAndIPaymentAmount);
        ms.amortizationInterest = am;
        ms.amortizationPrincipal = ms.totalLoanAmount;
        ms.interestDifference = 0;
      } catch (e) {
        Err.handle("updateCurrentScenarioCalcValues Exception duriing arithmetic operation" + e);
        return -1;
      }
    }
    function runcomparison() {
      let cnt = 0;
      for (const mortgagescenario of bean.value.savedScenariosList) {
        if (mortgagescenario.savedSelected) cnt++;
      }
      if (cnt < 1 || cnt > 3) {
        showToast("error", i18n.t("financial-tools.sc_comp_sel_max3").toString());
        return;
      }
      updateCurrentScenarioCalcValues();
      populateSelectedScenarios();
    }
    function selectScenarios(doall) {
      for (const mortgagescenario of bean.value.savedScenariosList) {
        mortgagescenario.savedSelected = doall;
      }
    }
    function deleteSelected() {
      const sl = bean.value.savedScenariosList;
      bean.value.savedScenariosList = _filterInstanceProperty(sl).call(sl, e => !e.savedSelected);
    }
    return {
      formatMoney,
      formatRate,
      formatTerm,
      MORTGAGE_FREQUENCY,
      lowerCase,
      showSaved,
      runcomparison,
      selectScenarios,
      deleteSelected
    };
  }
});